export default Object.freeze({
    BACKUP_TYPES: [
        'full',
        'incremental',
        // 'binarylog', // TODO: Bring back once PITR issue is resolved
        'dump',
        'snapshot'
    ],
})
